import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCancellationPolicies } from 'modules/settings/api';

export const useQueryCancellationPolicies = (partnerId?: number) => {
  return useQuery(
    [QUERY_KEYS.SETTINGS_CANCELLATION_POLICIES, partnerId],
    () => getCancellationPolicies(partnerId!),
    {
      enabled: !!partnerId,
      staleTime: 5 * 60 * 1000,
      keepPreviousData: true,
    },
  );
};
